import { AnnouncementValidation } from '../types';

const initAnnouncementValid: AnnouncementValidation = {
  Title: { isErr: false, errMsg: '', canNotSave: true },
  Description: { isErr: false, errMsg: '', canNotSave: true },
  ExpireDate: { isErr: false, errMsg: '', canNotSave: true },
};

export const loadedAnnouncementValid: AnnouncementValidation = {
  Title: { isErr: false, errMsg: '', canNotSave: false },
  Description: { isErr: false, errMsg: '', canNotSave: false },
  ExpireDate: { isErr: false, errMsg: '', canNotSave: false },
};

export default initAnnouncementValid;
